import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ContentItem from './components/ContentItem';

const Styled = styled.div``;

const ContentItems = ({ className, items }) => (
  <Styled className={className} data-test="content-item">
    {items.map((item, index) => (
      <ContentItem key={index} item={item} />
    ))}
  </Styled>
);

ContentItems.propTypes = {
  items: PropTypes.array.isRequired,
};

export default ContentItems;



// WEBPACK FOOTER //
// ./src/components/ContentItems/index.js